import { get } from "../../utils/objectHelpers";

$ {
    const title = get(input, "title", {});
    const descriptions = get(input, "subTitles", []);
    const sections = get(input, "sections", []);
}

<div class="str-about-description about-layout--gutters">
    <div class="str-about-description__about-intro">
        <h2 class="str-about-description__title">
            <str-textual-display ...title />
        </h2>
        <div class="str-about-description__description" data-test-id="about-description">
            <for|description| of=descriptions>
                <str-textual-display allowHtml=true class="str-about-description__description regular-text" ...description/>
            </for>
        </div>
    </div>
    <div class="str-about-description__seller-info">
        <for|section| of=sections>
            $ {
                const title = get(section, "title", {});
                const action = get(section, "action", {});
            }
            <str-textual-display ...title action=action />
        </for>
    </div>
</div>
